<template>

    <div class="match">
        <div :class="['chip', matchStyle ]">
            {{translationVariant.matchPercent}}%
        </div>
    </div>

</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { Translation } from '@/models/TranslationVariants';

    export default defineComponent({
        props: {
            translationVariant: {
                type: Object as PropType<Translation>,
                mandatory: true
            }
        },
        computed: {
            matchStyle(): string{
                const matchPersent = this.translationVariant ? this.translationVariant.matchPercent : 0;

                switch (true) {
                    case (matchPersent == 100):
                        return 'match-100';
                    case (matchPersent > 90):
                        return 'match-99';
                    case (matchPersent > 80):
                        return 'match-90';
                    case (matchPersent > 70):
                        return 'match-80';
                    case (matchPersent > 60):
                        return 'match-70';
                    default:
                        return 'match-60';
                }
            },
        },
    })

</script>

<style lang="scss" scoped>

    .chip {
        padding: 3px 10px;
        border-radius: 18px;
        display: flex;
        justify-content: center;
        width: fit-content;
        color: var(--text-color);
    }

    .match {
        display: flex;
        justify-content: center;


        &-100 {
            background-color: var(--match-100);
            color: var(--white);
        }

        &-99 {
            background-color: var(--match-till-99);
        }

        &-90 {
            background-color: var(--match-till-90);
        }

        &-80 {
            background-color: var(--match-till-80);
        }

        &-70 {
            background-color: var(--match-till-70);
        }

        &-60 {
            background-color: var(--match-till-60);
        }
    }

</style>